import { IHttpClient, HttpRequest } from "@features/shared/request/model";
import {
    CreateOnboardingSessionPayload,
    OnboardingSessionResponse,
    UpdateOnboardingSessionPayload
} from "@features/shared/entities/session";

const SERVER_URL = `${process.env.NEXT_PUBLIC_API_URL}`;

class OnboardingSessionsApi {
    constructor(private readonly httpClient: IHttpClient) {}

    create(payload: CreateOnboardingSessionPayload) {
        return this.httpClient.do<OnboardingSessionResponse>(`${SERVER_URL}/onboarding/sessions`, "POST", payload);
    }

    get(sessionId: string) {
        return this.httpClient.do<OnboardingSessionResponse>(`${SERVER_URL}/onboarding/sessions/${sessionId}`, "GET");
    }

    update(sessionId: string, payload: UpdateOnboardingSessionPayload) {
        return this.httpClient.do<OnboardingSessionResponse>(
            `${SERVER_URL}/onboarding/sessions/${sessionId}`,
            "PATCH",
            payload
        );
    }
}

export const OnboardingSessionsApiClient = new OnboardingSessionsApi(HttpRequest);
